export default function(ac, app) {
    var materijal = app.getEntity('Materijal');

    materijal.listView()
        .title('Materijali')
        .icon('<i class="fa fa-archive fa-3x"></i>')
        .fields([
            ac.field('naziv')
        ])
        .listActions([
            'edit',
            'delete'
        ]);

    materijal.editionView()
        .title('Materijal')
        .fields([
            {
                key:'naziv',
                type: 'hInput',
                templateOptions: {
                    label: 'Naziv',
                    required: true,
                    focus: true
                }
            },
        ]);

    return materijal;
}



// WEBPACK FOOTER //
// ./app/components/materijal/config.js